import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom'
import MediaQuery from 'react-responsive';

import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { getColor } from '../../../common/ThemeService';

const ERROR_TEXT = [
    { value: 0.2, text: "small error" },
    { value: 0.5, text: "medium error" },
    { value: 1, text: "significant error" },
    { value: 2, text: "major error" }];

class SpinErrorTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        }
    }


    render() {
        const themeColor = getColor();
        const errorValueToolTip = this.props.i18next.t("lable.errorTooltip1")
        const optimalActionToolTip = this.props.i18next.t("lable.errorTooltip2")
        return (
            <div>
                <ReactTooltip />

                <table className="spinRepo_table" style={{
                    width: "100%",
                    fontSize: "14px",
                    color: '#020202',
                    backgroundColor: "#9797970d"
                }}>
                    <thead className="bottom hideMobile" >
                        <tr className="">
                            <th className={"spinError-th spin-dateHoleCardColWidth hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')}>{this.props.i18next.t("lable.dateAndtime")}</th>
                            <th className="spinError-th spin-dateHoleCardColWidth">{this.props.i18next.t("lable.pocketCards")}</th>
                            <th width='12%' className="spinError-th hideOrShowPopInMobile " >{this.props.i18next.t("lable.Position")}</th>
                            {this.props.ismodal && <th width='12%' className={"spinError-th hideOrShowPopInMobile "}>{this.props.i18next.t("lable.errorType")}</th>}
                            <th width='12%' className={"spinError-th hideOrShowPopInMobile "}>Error Text&nbsp;<i style={{ color: themeColor }} className="fa fa-question-circle" data-tip={errorValueToolTip} aria-hidden="true"></i></th>
                            <th width='12%' className={"spinError-th hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')} >{this.props.i18next.t("lable.myAction")}</th>
                            <th width='30%' className={"spinError-th hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')} style={{ width: "auto" }}>{this.props.i18next.t("lable.optimalAction")}&nbsp;<i style={{ color: themeColor }} className="fa fa-question-circle" data-tip={optimalActionToolTip} aria-hidden="true"></i></th>
                            {!this.props.ismodal ?
                                <MediaQuery maxWidth={991} >
                                    <th width='38%' className={"spinError-th "}>{this.props.i18next.t("lable.profitActions")}</th>
                                </MediaQuery>
                                : <th width='38%' className={"spinError-th propsForMob"}>{this.props.i18next.t("lable.profitActions")}</th>}

                            <th width='3.78%' className="spinError-th"></th>
                        </tr>
                    </thead>
                    <tbody className="">
                        {this.props.errorHands&&this.props.errorHands.hands&&this.props.errorHands.hands.map((key, index) => {
                             let errorValues = ERROR_TEXT.find((item)=>{
                                 if(key.errorValue<=item.value){
                                     return item
                                 }
                             });
                             if(errorValues === undefined) {
                                 errorValues  = {
                                     'text':'major error'
                                 }
                             }
                            return (
                                <tr className="bottom" key={index} >
                                    <td className={"spinError-tr hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')}>
                                        <tr><td style={{ color: '#828282' }}>{moment(key.dataTime.value).format("HH:mm")}</td></tr>
                                        <tr><td style={{ color: '#828282' }}>{moment(key.dataTime.value).format("DD/MM/YYYY")}</td></tr>
                                    </td>
                                    <td className="spinError-tr " >
                                        {key.PocketCards.map((cardUrl, i) => {
                                            return cardUrl ? <img key={i} src={cardUrl} className="spinErrorCards" /> : <div className="spinErrorCards" ></div>
                                        })}
                                    </td>
                                    <td className="spinError-tr hideOrShowPopInMobile">{key.positions}&nbsp;<i style={{ color: themeColor }} className="fa fa-question-circle" data-tip={key.toolTip} aria-hidden="true"></i></td>
                                    {this.props.ismodal && <td className={"spinError-tr hideOrShowPopInMobile "} >
                                        {key.errorType}&nbsp;<i style={{ color: themeColor }} className="fa fa-question-circle" data-tip={key.errortoolTip} aria-hidden="true"></i>
                                    </td>}
                                    <td className={"spinError-tr hideOrShowPopInMobile "} >{errorValues.text}</td>
                                    <td className={"spinError-tr hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')} >{key.heroAction}</td>
                                    <td className={"spinError-tr hideOrShowPopInMobile " + (this.props.ismodal ? '' : 'displayProp')} >{key.optimalAction}</td>
                                    {!this.props.ismodal ?
                                        <tr className="displayTablets" >
                                            <td style={{ color: key.profit < 0 ? '#828282' : '#6DB92C', paddingTop: '13.87px' }}><div>{key.profit < 0 ? key.profit : '+' + key.profit}</div></td>
                                            <tr className="displayTablets">
                                                <td ><div>{this.props.i18next.t("lable.myAction")}:{key.heroAction}</div></td>
                                            </tr>
                                            <tr className="displayTablets">
                                                <td style={{ paddingBottom: '15.55px' }}><div>{this.props.i18next.t("lable.optimalAction")}:{key.optimalAction}</div></td>
                                            </tr>
                                        </tr>
                                        : <tr className="displayTablets propsForMob" >
                                            <td style={{ color: key.profit < 0 ? '#828282' : '#6DB92C', paddingTop: '13.87px' }}><div>{key.profit < 0 ? key.profit : '+' + key.profit}</div></td>
                                            <tr className="displayTablets">
                                                <td ><div>{this.props.i18next.t("lable.myAction")}:{key.heroAction}</div></td>
                                            </tr>
                                            <tr className="displayTablets">
                                                <td style={{ paddingBottom: '15.55px' }}><div>{this.props.i18next.t("lable.optimalAction")}:{key.optimalAction}</div></td>
                                            </tr>
                                        </tr>
                                    }
                                    <td className="spinError-tr" style={{ width: "40px" }} >
                                        <i className="fa fa-play-circle  spinPlay-btn" style={{ float: "right", color: themeColor }}
                                            onClick={(e) => { e.preventDefault(); this.props.handReplayerOpen(key); }}></i>
                                    </td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}
export default withRouter(SpinErrorTable);


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Spin/SpinErrorTable.js
 **/